import { OlCommission } from '../../../lib/types/models/ol/commission/ol-commission'
import { OlCommissionInput } from '../../../lib/types/models/ol/commission/ol-commission-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateOlCommission = async (data: UpdateInput<OlCommissionInput>) => {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.ols.updateOlCommission.url, { id }))
    .patch<OlCommission, Partial<OlCommissionInput>>(rest)
}
